import * as IActions from 'ApplicationEntry/ducks/ProductsRiders/icrtn';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import {ICRTN as I} from 'ApplicationEntry/models/ProductsRiders/ICRTN/ICRTN';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {ICRTNProductTypes} from 'ApplicationEntry/models/ProductsRiders/ProductTypes';

type ICRTNProps = {
  icrtn: I;
};

const Icrtn = (props: ICRTNProps) => {
  const dispatch = useDispatch();
  const {
    planType,
    productType,
    icrUnits,
    groupTrust,
    ropRider,
    overRideBillForm,
    originalAge,
    reRate,
    calculatedPremium,
    cwa,
    policyNumber,
    replacement,
    section125,
  } = props.icrtn;

  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [productBlurred, setBlurProduct] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const showProductError = productBlurred && productType.key === 'Empty';
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [icrUnitsLabel, setICRUnitsLabel] = useState<HTMLLabelElement | null>();
  const [productLabel, setProductLabel] = useState<HTMLLabelElement | null>();

  const showPolicyNumberError =
    policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && (reRate || replacement);

  return (
    <>
      <div className="product-riders-section__policy-type" id="cancer-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showProductError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setProductLabel} id="product-label">
                    Product Type
                  </InputLabel>
                  <Select
                    labelId="product-label"
                    labelWidth={productLabel?.clientWidth}
                    fullWidth
                    id="product"
                    value={productType.value}
                    onBlur={() => setBlurProduct(true)}
                    onChange={e => dispatch(IActions.changeProductType(e.target.value as string))}
                  >
                    {ICRTNProductTypes.map((productTypes, index) => (
                      <MenuItem value={productTypes} key={index}>
                        {productTypes}
                      </MenuItem>
                    ))}
                  </Select>
                  {showProductError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid>

            {productType.key === 'NonEmpty' ? (
              <>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel ref={setICRUnitsLabel} id="cancer-policy-option-label">
                        ICR Units
                      </InputLabel>
                      <Select
                        labelId="cancer-label-policy-option"
                        labelWidth={icrUnitsLabel?.clientWidth}
                        id="cancer-policy-option"
                        value={icrUnits.key === 'Empty' ? '' : icrUnits.value}
                        onChange={e => {
                          dispatch(IActions.changeICRUnits(e.target.value as string));
                        }}
                      >
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="6">6</MenuItem>
                        <MenuItem value="7">7</MenuItem>
                        <MenuItem value="8">8</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      error={showPlanTypeError}
                      variant="outlined"
                      className="product-riders-section__policy-type__form__row--field"
                    >
                      <InputLabel ref={setPlanTypeLabel} id="cancer-plantype-label">
                        Plan Type
                      </InputLabel>
                      <Select
                        labelId="cancer-label-plantype"
                        labelWidth={planTypeLabel?.clientWidth}
                        id="critical-illness-plantype"
                        value={planType.key === 'Empty' ? '' : planType.value}
                        onBlur={() => setBlurPlanType(true)}
                        onChange={e => {
                          dispatch(IActions.changePlanType(e.target.value as string));
                        }}
                      >
                        <MenuItem value="IND">Individual</MenuItem>
                        <MenuItem value="FAMILY">Family</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-group-trust"
                          checked={groupTrust}
                          onChange={() => dispatch(IActions.changeGroupTrust(!groupTrust))}
                          disabled
                        />
                      }
                      label={<Typography>Group Trust</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-replacement"
                          checked={replacement}
                          onChange={() => {
                            dispatch(IActions.changeReplacement(!replacement));

                            if (replacement && !reRate) {
                              dispatch(IActions.changePolicyNumber(''));
                            }
                          }}
                        />
                      }
                      label={<Typography className="case-details-section__checkbox-label">Replacement</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-original-age"
                      label="Original Age"
                      variant="outlined"
                      placeholder="Enter Original Age"
                      margin="normal"
                      fullWidth
                      type="number"
                      className="product-riders-section__policy-type__form__row--field"
                      value={!replacement ? '' : originalAge}
                      onChange={e => dispatch(IActions.changeOriginalAge(parseInt(e.target.value, 10)))}
                      disabled={!replacement}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-rerate"
                          checked={reRate}
                          onChange={() => {
                            dispatch(IActions.changeRerate(!reRate));

                            if (reRate && !replacement) {
                              dispatch(IActions.changePolicyNumber(''));
                            }
                          }}
                        />
                      }
                      label={<Typography className="case-details-section__checkbox-label">Re-rate</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-policy-number"
                      label="Policy Number"
                      variant="outlined"
                      placeholder="Enter Policy Number"
                      margin="normal"
                      fullWidth
                      error={showPolicyNumberError}
                      helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                      className="product-riders-section__policy-type__form__row--field"
                      value={
                        policyNumber.key !== 'ValidPolicyNumber' || (!reRate && !replacement)
                          ? ''
                          : policyNumber.value.value
                      }
                      onBlur={() => setPolicyNumberBlurred(true)}
                      onChange={e => dispatch(IActions.changePolicyNumber(e.target.value as string))}
                      disabled={!reRate && !replacement}
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedOverrideBillForm"
                          color="secondary"
                          id="cancer-override-bill-form"
                          checked={overRideBillForm}
                          onChange={() => dispatch(IActions.changeOverrideBillForm(!overRideBillForm))}
                          disabled
                        />
                      }
                      label={<Typography>Override Bill Form To Direct</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedSection125"
                          color="secondary"
                          id="cancer-section125"
                          checked={section125}
                          onChange={() => dispatch(IActions.changeSection125(!section125))}
                        />
                      }
                      label={<Typography>Section 125</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-premium"
                      label="Premium"
                      variant="outlined"
                      placeholder="Enter Premium"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={calculatedPremium.value}
                      onChange={event => {
                        dispatch(IActions.changePremium(event.target.value as string));
                        dispatch(IActions.changeCalculatedPremium(event.target.value as string));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-cwa"
                      label="CWA"
                      variant="outlined"
                      placeholder="Enter CWA"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={cwa.value}
                      onChange={e => dispatch(IActions.changeCWA(e.target.value as string))}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedROPRider"
                          color="secondary"
                          id="cancer-ropRider"
                          checked={ropRider}
                          onChange={() => dispatch(IActions.changeROPRider(!ropRider))}
                          disabled
                        />
                      }
                      label={<Typography>ROP Rider</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                </Grid>
              </>
            ) : null}
          </div>
        </form>
      </div>
    </>
  );
};

export default Icrtn;
